import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CancelOutlined from '@material-ui/icons/CancelOutlined';
import FileCopy from '@material-ui/icons/FileCopy';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import MoreVert from '@material-ui/icons/MoreVert';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';

const DashboardWidgetMenu = (props) => {
  const { widget, handleDelete, handleDuplicate, handleNewTab, handleBookmark } = props;
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleClick = (event) => {
    event.preventDefault();
    setOpen(true);
    setAnchorEl(event.target);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const menuItemClick = (handlerFunction) => {
    handlerFunction(widget);
    handleClose();
  };
  const handleDialogOpen = () => {
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogDelete = () => {
    menuItemClick(handleDelete);
    setDialogOpen(false);
  };

  return (
    <div>
      <Button
        id={`${widget.i}-menu-button`}
        aria-controls="basic-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreVert />
      </Button>
      <Menu
        id={`${widget.i}-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          onClick={() => {
            menuItemClick(handleNewTab);
          }}
        >
          <ListItemIcon>
            <OpenInNewIcon />
          </ListItemIcon>
          <ListItemText>Open in new tab</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            menuItemClick(handleBookmark);
          }}
        >
          <ListItemIcon>{widget.bookmark ? <BookmarkIcon /> : <BookmarkBorderIcon />}</ListItemIcon>
          <ListItemText>Bookmark</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            menuItemClick(handleDuplicate);
          }}
        >
          <ListItemIcon>
            <FileCopy />
          </ListItemIcon>
          <ListItemText>Duplicate</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDialogOpen}>
          <ListItemIcon>
            <CancelOutlined />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>
      {dialogOpen && (
        <Dialog
          open={dialogOpen}
          onClose={handleDialogClose}
          aria-labelledby="dialog-title"
          aria-descibedby="dialog-description"
        >
          <DialogTitle style={{ textAlign: 'center' }} id="dialog-title">
            Are you sure you want to delete?
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="dialog-description">
              Deleting this widget will permanently remove it from the system along with the data.
              <b style={{ color: '#f44336' }}> This action cannot be undone.</b>
            </DialogContentText>
            <DialogActions style={{ justifyContent: 'center' }}>
              <Button
                variant="text"
                style={{ color: '#707070', height: '40px', width: '110px' }}
                onClick={handleDialogClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                style={{
                  backgroundColor: '#f44336',
                  color: '#fff',
                  height: '40px',
                  width: '110px,',
                }}
                onClick={handleDialogDelete}
              >
                Delete
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

DashboardWidgetMenu.propTypes = {
  widget: PropTypes.shape({
    i: PropTypes.string.isRequired,
    bookmark: PropTypes.bool,
  }).isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleDuplicate: PropTypes.func.isRequired,
  handleNewTab: PropTypes.func.isRequired,
  handleBookmark: PropTypes.func.isRequired,
};

export default DashboardWidgetMenu;
